<section class="vehicle-details-wpr">
    <div class="filter-section mt-3" style="background-color: white;">
        <div class="container" style="background-color: #d6d6d661; padding: 15px; border-radius: 8px;">
            <div class="row">
                <div class="col-lg-12">
                    <div class="vehicle-details-heading">
                        <div>
                            <h1>
                                <span routerLink="/vehicle">{{vehicleDetails?.carDescription}}</span>
                            </h1>
                            <ul class="product-details">
                                <li>
                                    <h5 class="product-title-info">{{ 'Vehicle-Details.location' | translate }}: <span
                                            class="product-title-info-value">{{vehicleDetails?.branchs}}</span></h5>
                                </li>
                                <li>
                                    <h5 class="product-title-info">{{ 'Vehicle-Details.sequence-no' | translate }}:<span
                                            class="product-title-info-value">{{vehicleDetails?.auctionDisplayNo}} <span *ngIf="vehicleDetails?.lane != 'unassigned'">({{vehicleDetails?.lane}})</span></span>
                                    </h5>
                                </li>
                            </ul>
                        </div>
                        <div class="v-d-btn-wpr"
                            *ngIf="isAuctionVehicle && vehicleDetails?.inventoryStatus != 3 && vehicleDetails?.auctionVehicleStatus != 'sold' && vehicleDetails?.isLoading != false">
                            <a *ngIf="isPreviousCarAvailable"
                                class="secondary-btn secondary-btn_border-round secondary-btn__gray"
                                (click)="GetAuctionVehicleByDisplay('p')"><span
                                    style="color: white; cursor: pointer;">{{ 'Vehicle-Details.previous' | translate
                                    }}</span></a>
                            <a *ngIf="isNextCarAvailable" class="secondary-btn secondary-btn_border-round details-btn"
                                (click)="GetAuctionVehicleByDisplay('n')"><span
                                    style="color: white; cursor: pointer;">{{ 'Vehicle-Details.next' | translate
                                    }}</span></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="container" style="margin-top: 15px;">
        <div class="row">
            <div class="col-md-8">
                <div>
                    <div class="row p-slider">
                        <div class="col-md-3 slider-thumbnail">
                            <div class="" *ngFor="let i of filterImage(vehicleDetails?.vinimages)">
                                <img [lazyLoad]="sharedService.cloudFrontUrl('400x300',i?.image)"
                                    [defaultImage]="i?.image ? i?.image : '../../../assets/img/default-car123123.jpg'"
                                    alt="" (click)="onClickImage(i?.image)">
                            </div>
                        </div>
                        <div class="col-md-9 slider-details-wpr" style="position: relative;">
                            <i class="fa fa-chevron-right" (click)="nextImage()" style="
                                color: white;
                                font-size: 28px;
                                position: absolute;
                                top: 50%;
                                z-index: 1 !important;
                                right: 22px;
                                cursor: pointer;
                                clip-path: circle(42%);
                                backdrop-filter: blur(2px);
                                padding: 10px;
                                background: rgb(255 255 255 / 25%);"></i>

                            <i class="fa fa-chevron-left " (click)="previousImage()" style="color: white;
                            font-size: 28px;
                            position: absolute;
                            top: 50%;
                            z-index: 1 !important;
                            left: 22px;
                            cursor: pointer;
                            clip-path: circle(42%);
                            backdrop-filter: blur(2px);
                            padding: 10px;
                            background: rgb(255 255 255 / 25%);"></i>
                            <div *ngIf="zoomImageClick">
                                <div class="img-zoom-container carImgZoomOut" (click)="onClickImageZoom()"
                                    (mouseenter)="imageZoom('myimage', 'myresult');">
                                    <img id="myimage" class="carImgZoomOut" (click)="onClickImageZoom()"
                                        [lazyLoad]="sharedService.cloudFrontUrl('600x500',showVehicle)"
                                        [defaultImage]="showVehicle ?showVehicle: '../../../assets/img/default-car123123.jpg'">
                                    <div id="myresult" (click)="onClickImageZoom()"
                                        class="img-zoom-result carImgZoomOut"></div>
                                    <div style=" width: 14px; height: 14px; top: 2%; position: absolute; left: 95%; transform: translateX(-50%);"
                                        *ngIf="(currentUser?.userType === 4 || currentUser?.userType === 5)">
                                        <a (click)="vehicleDetails?.watchList ? deleteWatchList(vehicleDetails?.watchList?._id) : addToWatchList()"
                                            style="margin-left: 5px;"
                                            [tooltip]="vehicleDetails?.watchList ? 'click to Remove' : 'click to add'">
                                            <i class="fa-solid fw-100 fa-bookmark tc-red fa-2x"
                                                [ngClass]="{'fw-1000' : vehicleDetails?.watchList}"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <!-- <div *ngIf="!zoomImageClick"><div>
                                    <img id="myimage" class="img-zoom-container carImgZoomIn"
                                        (click)="onClickImageZoom()"
                                        [lazyLoad]="sharedService.cloudFrontUrl('600x500',showVehicle)"
                                        [defaultImage]="showVehicle ? showVehicle: '../../../assets/img/default-car123123.jpg'"
                                        height="100%" width="100%" style="border-radius: 10px;">
                                    <div id="myresult" class="img-zoom-result"></div>
                                    <div style="top: 2%;
                                    position: absolute;
                                    left: 95%; 
                                    transform: translateX(-50%);"
                                        *ngIf="currentUser?.userType === 4 || currentUser?.userType === 5">
                                        <a (click)="vehicleDetails?.watchList ? deleteWatchList(vehicleDetails?.watchList?._id) : addToWatchList()"
                                            style="margin-left: 5px;"
                                            *ngIf="vehicleDetails?.inventoryStatus != 3 && vehicleDetails?.auctionVehicleStatus != 'sold' && vehicleDetails?.isLoading != false"
                                            [tooltip]="vehicleDetails?.watchList ? ('tooltips.click-to-remove' | translate) : ('tooltips.click-to-add' | translate)">
                                            <i class="fa-solid fw-100 fa-bookmark tc-red fa-2x"
                                                [ngClass]="{'fw-1000' : vehicleDetails?.watchList}"></i>
                                        </a>
                                    </div>
                                </div>
                            </div> -->
                             <div class="img-zoom-container" *ngIf="!zoomImageClick">
                                                        <img id="myimage" class="img-zoom-container carImgZoomIn"
                                                            (click)="onClickImageZoom()"
                                                            [lazyLoad]="sharedService.cloudFrontUrl('600x500',showVehicle)"
                                        [defaultImage]="showVehicle ? showVehicle: '../../../assets/img/default-car123123.jpg'"
                                                            style="height: 100%;">
                                                             <img *ngIf="auctionDetail?.cashbackId && vehicleDetails?.shouldIncludeInCashbackAuction === true"
                                                                src="../../../../assets/images/newGifCashbackValid.gif"
                                                                class="cashback-flip"
                                                                style="
                                                                    position: absolute;
                                                                    top: 0;
                                                                    left: 0;
                                                                    width: 100%;
                                                                    height: 100%;
                                                                    object-fit: cover;
                                                                    opacity: 0.85;
                                                                    pointer-events: none;
                                                                "/>
                                                             <img *ngIf="auctionDetail?.cashbackId && vehicleDetails?.shouldIncludeInCashbackAuction  !== true"
                                                                src="../../../assets/images/newGifCashbackNotValid.gif"
                                                                class="cashback-flip"
                                                                style="
                                                                    position: absolute;
                                                                    top: 0;
                                                                    left: 0;
                                                                    width: 100%;
                                                                    height: 100%;
                                                                    object-fit: cover;
                                                                    opacity: 0.85;
                                                                    pointer-events: none;
                                                                "/>

                                                        <div id="myresult" class="img-zoom-result"></div>
                                                         <div style="top: 2%;
                                    position: absolute;
                                    left: 95%; 
                                    transform: translateX(-50%);"
                                        *ngIf="currentUser?.userType === 4 || currentUser?.userType === 5">
                                        <a (click)="vehicleDetails?.watchList ? deleteWatchList(vehicleDetails?.watchList?._id) : addToWatchList()"
                                            style="margin-left: 5px;"
                                            *ngIf="vehicleDetails?.inventoryStatus != 3 && vehicleDetails?.auctionVehicleStatus != 'sold' && vehicleDetails?.isLoading != false"
                                            [tooltip]="vehicleDetails?.watchList ? ('tooltips.click-to-remove' | translate) : ('tooltips.click-to-add' | translate)">
                                            <i class="fa-solid fw-100 fa-bookmark tc-red fa-2x"
                                                [ngClass]="{'fw-1000' : vehicleDetails?.watchList}"></i>
                                        </a>
                                    </div>
                                                    </div>


                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="screenWidth && screenWidth < 768">
                    <div class="col-md-12" style="margin-top: 10px;">
                        <div class="d-flex" style="overflow: overlay; width: 100%; ">
                            <div class="" *ngFor="let i of filterImage(vehicleDetails?.vinimages)">
                                <img style="max-width: 100px; margin-right: 10px;
                                            max-height: 100px;
                                            cursor: pointer;"
                                    [lazyLoad]="sharedService.cloudFrontUrl('400x300',i?.image)"
                                    [defaultImage]="i?.image ? i?.image : '../../../assets/img/default-car123123.jpg'"
                                    alt="" (click)="onClickImage(i?.image)">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-details-wpr">
                    <ul class="product-discription">
                        <li class="card">
                            <i class="fas fa-tachometer-alt">
                            </i>
                            <h6 class="mb-0">{{vehicleDetails?.engines}} ltr</h6>
                        </li>
                        <li  class="card" [tooltip]="vehicleDetails?.mileageUnit === 'mi' ? (vehicleDetails?.milage * 1.60934).toFixed(0) + ' km' : ''">
                            <i class="fas fa-road">
                            </i>
                            <h6 class="mb-0">{{vehicleDetails?.milage === 0 || vehicleDetails?.milage === 1 ? '-' :
                                vehicleDetails?.milage }} {{vehicleDetails?.mileageUnit?vehicleDetails?.mileageUnit:' mi'}}</h6>
                        </li>
                        <li class="card">
                            <i class="fas fa-gas-pump">
                            </i>
                            <h6 class="mb-0">{{vehicleDetails?.fueltypes ? vehicleDetails?.fueltypes : 'NA'}}</h6>
                        </li>
                        <li class="card">
                            <i class="fas fa-cogs">
                            </i>
                            <h6 class="mb-0">{{vehicleDetails?.drivetypes ? vehicleDetails?.drivetypes : 'NA'}}</h6>
                        </li>
                        <li class="card">
                            <i class="fa-solid fa-key"></i>
                            <h6 class="mb-0">{{vehicleDetails?.isKeyAvailable == true ? 'Yes' : 'No'}}</h6>
                        </li>
                                <li class="card"
                                    *ngIf="vehicleDetails?.startCode &&
                                        (vehicleDetails?.startCode?.title?.split(' ').join('-').toLowerCase() === 'engine-start' ||
                                        vehicleDetails?.startCode?.title?.split(' ').join('-').toLowerCase() === 'run-&-drive')"

                                    (mouseenter)="showStartTooltip(vehicleDetails)"
                                    (mouseleave)="hideStartTooltip()"
                                    style="cursor: pointer;">

                                    <img
                                        [src]="'assets/icons/start-code/' + 
                                            (vehicleDetails?.startCode?.title?.split(' ').join('-').toLowerCase()) + '.gif'"
                                        alt="">
                                </li>
                        </ul>
                        <div class="start-tooltip-global" *ngIf="showTooltip">
                            <strong>{{ tooltipData?.title }}</strong><br>
                            <span>{{ tooltipData?.description }}</span>
                        </div>
                </div>
                <div>
                </div>
                <div class="vehicle-info">
                </div>
            </div>
            <div class="col-md-4">
                <div class="card bid-info-card"
                    *ngIf="vehicleDetails?.inventoryStatus == 3 && vehicleDetails?.auctionVehicleStatus == 'sold' &&  vehicleDetails?.isLoading != false">
                    <img src="../../assets/img/sold-stamp.png">
                </div>

                <div *ngIf="vehicleDetails?.clean_title"
                    class="card shadow-sm border-success clean-title-card flip-down mt-0" (click)="openCleanTitlePDF()">
                    <div class="card-body d-flex justify-content-between align-items-center"
                        style="background-color: rgb(207 252 207 / 40%); padding: 8px 15px;">
                        <div class="d-flex align-items-center gap-3">
                            <i class="fa-solid fa-circle-check text-success fs-3"></i>
                            <div class="ml-2">
                                <h5 class="card-title mb-0">{{ vehicleDetails?.clean_title ? 'Clean Title Verified' :
                                    'Verification Pending' }}</h5>
                                <p class="card-text text-muted mb-0 mt-0" style="font-size: 13px; font-weight: 300;">All
                                    documents verified and clear</p>
                            </div>
                        </div>

                        <span class="badge px-3 py-2 d-flex align-items-center btn-verified-pdf">
                            <i class="fa-solid fa-check mr-1"></i> Verified
                        </span>
                    </div>
                </div>

                <div class="card bid-info-card"
                    *ngIf="vehicleDetails?.inventoryStatus==1 || vehicleDetails?.inventoryStatus==2">
                    <div>
                        <div class="table-responsive table-card table-style-2">
                            <table class="table table-borderless table-centered align-middle table-nowrap mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th scope="col" colspan="2" style="border-top: none;">{{
                                            'Vehicle-Details.bid-information' | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="border-top: none;">{{ 'Vehicle-Details.eligibility-status' |
                                            translate }}</td>
                                        <td class="text-right" style="border-top: none;" *ngIf="currentUser">
                                            {{currentUser?.creditLimit >=
                                            customBid ? 'Eligible' : 'Not Eligible'}}</td>
                                        <td class="text-right" style="border-top: none;" *ngIf="!currentUser">Not
                                            Eligible</td>
                                    </tr>
                                    <tr>
                                        <td style="border-top: none;">{{ 'Vehicle-Details.starting-bid' | translate }}
                                        </td>
                                        <td class="text-right" style="border-top: none;"><svg id="Logo"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 344.84 299.91"
                                                width="0.9em" height="0.9em" class="text-danger mr-1 mb-1">
                                                <path fill="currentColor"
                                                    d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z" />
                                            </svg>
                                            <span class="text-danger">{{vehicleDetails?.startingBid ?
                                                vehicleDetails?.startingBid : 0}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="border-top: none;">{{ 'Vehicle-Details.bid-status' | translate }}
                                        </td>
                                        <td class="text-right" style="border-top: none;">
                                            {{'buyers.buyer-section-5-sub-heading-button-2' | translate}}<span
                                                class="text-danger"></span></td>
                                    </tr>
                                    <tr>
                                        <td style="border-top: none;">{{ 'Vehicle-Details.current-prebid' | translate }}
                                        </td>
                                        <td class="text-right" style="border-top: none;">
                                            {{bidHistory?.bidDetails?.latestBidAmount ?
                                            bidHistory?.bidDetails?.latestBidAmount: 'Not Available'}}<span
                                                class="text-danger"></span></td>
                                    </tr>
                                    <tr>
                                        <td style="border-top: none;">{{ 'Vehicle-Details.your-bid' | translate }}</td>
                                        <td class="text-right" style="border-top: none;">
                                            {{bidHistory?.bidDetails?.userBidAmount ?
                                            bidHistory?.bidDetails?.userBidAmount : 'Not Available'}}<span
                                                class="text-danger"></span></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="text-center" style="color: #dc3545; border-top: none;"
                                            *ngIf="bidHistory ? bidHistory?.bidDetails?.latestBidAmount === bidHistory?.bidDetails?.userBidAmount : false">
                                            <b>{{ 'auctions.you-are-highest-bidder' | translate }}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="border-top: none;">
                                            <div>{{ 'Vehicle-Details.meke-pre-bid' | translate }} </div>
                                        </td>
                                        <td style="border-top: none;">
                                            <div class="bid-info">
                                                <button class="btn btn-outline-secondary"
                                                    (click)="decreaseVal('custome')">-</button>
                                                <div class="form-control readonly-default center-content"
                                                    id="pre-bid-val">{{customBid}}</div>
                                                <button class="btn btn-outline-secondary"
                                                    (click)="increaseVal('custome')">+</button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="border-top: none;">
                                            <div class="bid-info">
                                                <a (click)="showConfirmation()"
                                                    class="primary-btn primary-btn_border-round details-btn primary-btn__d-block"
                                                    style="cursor:pointer;"><span>{{'buyers.buyer-section-5-sub-heading-button-2'
                                                        | translate}}</span></a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="card mt-3">
                    <div>
                        <div class="table-responsive table-card table-style-2">
                            <table class="table table-borderless table-centered align-middle table-nowrap mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th scope="col" colspan="2" style="border-top: none;"><span
                                                *ngIf="isAuctionVehicle">{{ 'Vehicle-Details.auction-information' |
                                                translate }}
                                            </span><span *ngIf="!isAuctionVehicle">{{
                                                'Vehicle-Details.auction-information' | translate }}</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="border-top: none;">{{ 'Vehicle-Details.title' | translate }}</td>
                                        <td class="text-right" style="border-top: none;"><span
                                                *ngIf="isAuctionVehicle">{{auctionDetail?.title}}</span><span
                                                *ngIf="!isAuctionVehicle">N/A</span></td>
                                    </tr>
                                    <tr>
                                        <td style="border-top: none;">{{ 'Vehicle-Details.location' | translate }}</td>
                                        <td class="text-right" style="border-top: none;">{{vehicleDetails?.branchs}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="border-top: none;">{{ 'Vehicle-Details.sale-date' | translate }}</td>
                                        <td class="text-right" style="border-top: none;"><span
                                                *ngIf="isAuctionVehicle">{{auctionDetail?.auctionDate |
                                                localDate}}</span><span *ngIf="!isAuctionVehicle">N/A</span></td>
                                    </tr>
                                    <tr
                                        *ngIf="vehicleDetails?.inventoryStatus != 3 && vehicleDetails?.auctionVehicleStatus != 'sold' &&  vehicleDetails?.isLoading != false">
                                        <td style="border-top: none;">{{ 'Vehicle-Details.time-left' | translate }}</td>
                                        <td class="text-right" style="border-top: none;"><span class="text-danger"><span
                                                    *ngIf="isAuctionVehicle">{{transform(auctionDetail?.auctionDate)}}</span><span
                                                    *ngIf="!isAuctionVehicle">N/A</span></span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="card col-sm-12 mt-5" *ngIf="videos?.length>=1">
                    <div class="card-body">
                        <div>
                            <label for="priceForm" style="cursor: pointer;"
                                (click)="viewExteriorVedio = !viewExteriorVedio">Click here to <span
                                    *ngIf="!viewExteriorVedio">see</span><span *ngIf="viewExteriorVedio">hide</span>
                                exterior video</label>
                            <div *ngIf="viewExteriorVedio">
                                <video width="400" controls>
                                    <source [src]="videos[0]" type="video/mp4">
                                    Your browser does not support HTML5 video.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card col-sm-12 mt-5" *ngIf="videos?.length>=2">
                    <div class="card-body">
                        <div>
                            <label for="priceForm" style="cursor: pointer;"
                                (click)="viewInteriorVedio = !viewInteriorVedio">Click here to <span
                                    *ngIf="!viewInteriorVedio">see</span><span *ngIf="viewInteriorVedio">hide</span>
                                interior video</label>
                            <div *ngIf="viewInteriorVedio">
                                <video width="400" controls>
                                    <source [src]="videos[1]" type="video/mp4">
                                    Your browser does not support HTML5 video.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="card mt-4 mb-4">
                <div>
                    <!-- Tabs Navigation -->
                    <ul class="nav nav-tabs" id="vehicleTabs" style="border-bottom: none; flex-wrap: nowrap;">
                        <li class="nav-item">
                            <a class="nav-link" (click)="changeTab('vehicleInfo')" [ngClass]="{ 
                               'active': activeTab === 'vehicleInfo', 
                               'border-red': activeTab === 'vehicleInfo', 
                               'text-red': activeTab === 'vehicleInfo' 
                             }" style="font-size: 20px; font-weight: 600; border-top: none; cursor: pointer;">
                                {{ 'Vehicle-Details.vehicle-information' | translate }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" (click)="changeTab('additionalInfo')" [ngClass]="{ 
                               'active': activeTab === 'additionalInfo', 
                               'border-red': activeTab === 'additionalInfo', 
                               'text-red': activeTab === 'additionalInfo' 
                             }" style="font-size: 20px; font-weight: 600; border-top: none; cursor: pointer;">
                                {{ 'Vehicle-Details.parts-information' | translate }} <i
                                    class="fa-solid fa-circle-info"></i>
                            </a>
                        </li>
                    </ul>

                    <div class="tab-content mt-3">
                        <!-- Vehicle Information Tab -->
                        <div class="tab-pane"
                            [ngClass]="{ 'active': activeTab === 'vehicleInfo', 'show': activeTab === 'vehicleInfo' }">
                            <div class="table-responsive table-card table-style-2">
                                <table class="table table-borderless table-centered align-middle table-nowrap mb-0">
                                    <tbody>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.sequence-no' | translate }}</td>
                                            <td class="text-right">{{ vehicleDetails?.auctionDisplayNo}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.lot-no' | translate }}</td>
                                            <td class="text-right">{{ vehicleDetails?.lotNo }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.vin-no' | translate }} </td>
                                            <td class="text-right">
                                                <span *ngIf="currentUser">{{vehicleDetails?.vin}}</span>
                                                <span *ngIf="!currentUser">
                                                    {{ vehicleDetails?.vin.length > 8 ? '**' +
                                                    vehicleDetails?.vin.slice(-8) : vehicleDetails?.vin }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.key' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.key || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.radar' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.radar || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.battery' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.battery || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.body-type' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.bodys || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.engine-type' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.engines || 'NA'}} ltr</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.cylinders' | translate }}</td>
                                            <td class="text-right">{{ vehicleDetails?.cylinder !== null &&
                                                vehicleDetails?.cylinder !== undefined ? vehicleDetails.cylinder : 'NA'
                                                }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.drive-type' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.drivetypes || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.transmission-type' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.transmission || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.fuel-type' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.fueltypes || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.color-exterior' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.color || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.primary-damage' | translate }} </td>
                                            <td class="text-right">{{vehicleDetails?.primaryDamage || 'NA' }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.secondary-damage' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.secondaryDamage || 'NA'}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ 'Vehicle-Details.remarks' | translate }}</td>
                                            <td class="text-right">{{vehicleDetails?.inventoryRemarks || 'NA'}}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Additional Info Tab -->
                        <div class="tab-pane"
                            [ngClass]="{ 'active': activeTab === 'additionalInfo', 'show': activeTab === 'additionalInfo' }">
                            <div class="row mb-3" *ngIf="vehicleDetails?.inspection">
                                <div class="col-md-4 d-flex" *ngFor="let key of vehicleDetails?.inspection | keyvalue">
                                    <label class="col-lg-7 fw-bold text-muted" style="text-align: left;">{{ key.key |
                                        titlecase }}</label>
                                    <div class="col-lg-5 d-flex justify-content-end">
                                        <span class="fw-bolder fs-6 text-gray-900">
                                            <span *ngIf="key.value.status">
                                                <b>✅</b>
                                            </span>
                                            <span *ngIf="!key.value.status">
                                                <b>❌</b>
                                            </span>
                                        </span>
                                    </div>
                                </div>

                            </div>
                            <div class="row" *ngIf="!vehicleDetails?.inspection">
                                <h3 class="col-sm-12 text-center">No Information Found</h3>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </div>
        <div class="row mt-4"
            *ngIf="vehicleDetails?.inventoryStatus != 3 && vehicleDetails?.auctionVehicleStatus != 'sold' &&  vehicleDetails?.isLoading != false">
            <div class="col-lg-12">
                <h3 class="h3-heading">{{ 'Vehicle-Details.more-vehicles' | translate }}</h3>
                <div id="carCarousel" class="carousel slide" data-ride="false">
                    <div class="carousel-inner">
                        <div class="carousel-item" *ngFor="let carChunk of chunkedVehicleList; let i = index"
                            [class.active]="i === 0">
                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let car of carChunk">
                                    <div class="product-item product-item__style-2">
                                        <div class="product-header">
                                            <h5 class="product-title capitalize" style="cursor: pointer !important;"
                                                (click)="navigateToVehicleDetails(car)">
                                                {{ car?.carDescription }}
                                            </h5>
                                            <div>
                                                <h5>{{ 'Vehicle-Details.starting-bid' | translate }}:
                                                    <span class="product-title-info-highlited">
                                                        <svg id="Logo" xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 344.84 299.91" width=".9em" height=".9em"
                                                            class="mb-1">
                                                            <path fill="currentColor"
                                                                d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z" />
                                                        </svg> {{ car?.startingBid ?? 0
                                                        }}</span>
                                                </h5>
                                                <ul class="product-details">
                                                    <li>
                                                        <h5 class="product-title-info">{{ 'Vehicle-Details.lot-no' |
                                                            translate }}: <span class="product-title-info-value"
                                                                style="cursor: pointer !important;"
                                                                (click)="navigateToVehicleDetails(car)">
                                                                <span class="hov">{{ car?.lotNo }}</span></span></h5>
                                                    </li>
                                                    <li>
                                                        <h5 class="product-title-info">{{ 'Vehicle-Details.vin-no' |
                                                            translate }}: <span class="product-title-info-value"
                                                                style="cursor: pointer !important;"
                                                                (click)="navigateToVehicleDetails(car)">
                                                                <span class="hov">{{ car?.vin.length > 6 ? '**' : '' }}
                                                                    {{ car?.vin.length > 6 ? car?.vin.slice(-6) :
                                                                    car?.vin }}</span></span></h5>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="product-image">
                                                <img [lazyLoad]="sharedService.cloudFrontUrl('300x200', car?.singleImages)"
                                                    style="cursor: pointer !important;"
                                                    (click)="navigateToVehicleDetails(car)"
                                                    [defaultImage]="'../../../assets/img/default-car123123.jpg'"
                                                    loading="lazy" />
                                            </div>
                                        </div>
                                        <ul class="product-discription">
                                            <li> <i class="fas fa-tachometer-alt">
                                                </i>
                                                <h6>{{ car?.engines }} ltr</h6>
                                            </li>
                                            <li><i class="fa-solid fa-road"></i>
                                                <h6>{{ car?.milage === 0 || car?.milage === 1 ? '-' : car?.milage }} {{car?.mileageUnit ? car?.mileageUnit : ' mi'}}</h6>
                                            </li>
                                            <li><i class="fas fa-gas-pump">
                                                </i>
                                                <h6>{{ car?.fueltypes }}</h6>
                                            </li>
                                            <li><i class="fas fa-cogs">
                                                </i>
                                                <h6>{{ car?.drivetypes }}</h6>
                                            </li>

                                                  <!-- <li *ngIf="car?.startCode">
                                                                              <img
                                                [src]="'assets/icons/start-code/' + (car?.startCode?.title?.split(' ').join('-').toLowerCase()) + '.png'"
                                                alt=""
                                                style="width: 25px;margin-top: 7px;">
                                            </li> -->

                                            <li *ngIf="car?.startCode && 
                            (car?.startCode?.title?.split(' ').join('-').toLowerCase() === 'engine-start' || 
                              car?.startCode?.title?.split(' ').join('-').toLowerCase() === 'run-and-drive')"
                            style="cursor: pointer;">
                            <img
                              [src]="'assets/icons/start-code/' + (car?.startCode?.title?.split(' ').join('-').toLowerCase()) + '.gif'"
                              alt="" style="width: 100%;margin-top: 7px;">
                          </li>


                    
                                        </ul>
                                        <div class="product-footer">
                                            <div class="product-button">
                                                <a (click)="navigateToVehicleDetails(car)" class="primary-btn"><span>{{
                                                        'Vehicle-Details.prebid' | translate }}</span></a>
                                                &nbsp;
                                                <a (click)="navigateToVehicleDetails(car)"
                                                    class="secondary-btn secondary-btn__black"><span>{{
                                                        'Vehicle-Details.details' | translate }}</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="carousel-control-prev bootstrap" href="#carCarousel" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next bootstrap" href="#carCarousel" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
<ng-template #callAPIDialog>
    <div class="modal-body text-center">
        <div class="row">
            <div class="col-12">
                <img src="../../assets/images/warning.svg" style="height: 150px;" class="img-fluid mx-auto d-block"
                    alt="Warning Image">
            </div>
            <div class="col-12 mt-3">
                <h2><b>Warning</b></h2>
            </div>
            <div class="col-12 mt-2">
                <p>Please Login as a buyer.</p>
            </div>
            <div class="col-12 mt-3">
                <button type="button" class="btn btn-primary" (click)="dialogRef.hide()">OK</button>
            </div>
        </div>
    </div>
</ng-template>

<!-- <ng-template #callAPIDialog2>
  <div class="modal-header">
    <span class="font-weight-bold" style="font-size: 16px;">
      {{ selectedVehicle?.startCode?.title || 'No Title' }}
    </span>
    <button type="button" class="close pull-right" aria-label="Close" (click)="dialogRef?.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="col-lg-12">
      {{ selectedVehicle?.startCode?.description || 'No Description' }}
    </div>
  </div>
</ng-template> -->